import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, {
  ...appConfig,   // 👈 keep all existing appConfig providers
  providers: [
    ...appConfig.providers!, // 👈 important: spread existing providers
    importProvidersFrom(HttpClientModule),
    provideAnimations(),
    provideToastr({
      timeOut: 4000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton: false,
      progressBar: true,
      progressAnimation: 'increasing',
      newestOnTop: true,
      tapToDismiss: true,
      maxOpened: 3,
    }),
  ],
}).catch((err) => console.error(err));
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker Registered 👍");
      return registration.update();
    })
    .catch((err) => console.error("Service Worker registration failed:", err));
}

